export default __webpack_public_path__ + "static/media/rotationIcon.2de73eb9.svg";